/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'

// Components
import AnimateScaleIn from '../animation/AnimateScaleIn'

// Styles
import { FullWidthCarouselItemMain } from './index.style'

const FullWidthCarouselItem = ({ id, image, title, index, active }) => {
  return (
    <FullWidthCarouselItemMain index={index} active={active}>
      <AnimateScaleIn id={id}>
        <GatsbyImage
          image={image.gatsbyImageData}
          alt={title}
          width={1722}
          height={1150}
        />
      </AnimateScaleIn>
    </FullWidthCarouselItemMain>
  )
}

FullWidthCarouselItem.propTypes = {
  id: PropTypes.string.isRequired,
  image: PropTypes.object,
  title: PropTypes.string,
  active: PropTypes.bool,
}
export default FullWidthCarouselItem
